import { render, staticRenderFns } from "./RouterLinkButton.vue?vue&type=template&id=a000fa86&"
import script from "./RouterLinkButton.vue?vue&type=script&lang=ts&"
export * from "./RouterLinkButton.vue?vue&type=script&lang=ts&"
import style0 from "./RouterLinkButton.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports